import { useTranslation } from "react-i18next";
import { excludePaths } from "~/constants/paths";
import { useAccount } from "~/hooks/useAccount";
import { useMemo, useState } from "react";
import { Plans } from "../plans";
import CountdownTimer from "~/spocketUI/components/Countdown";
import Button from "~/spocketUI/components/Button";
import Modal from "~/spocketUI/components/Modal";
import dayjs from "dayjs";

import * as S from "./TryForFreeBanner.style";
import { useStore } from "~/hooks/useStore";
import { useMediaQuery } from "~/spocketUI/hooks/useMediaQuery";

export const TryForFreeBanner = () => {
  const { t } = useTranslation();
  const { account } = useAccount();
  const { store } = useStore();
  const [show, setShow] = useState(false);
  const newDate = dayjs(account?.created_at).add(30, "minutes").toDate();
  const storeDate = dayjs(store?.last_updated_at).add(30, "minutes").toDate();
  const date = store ? storeDate : newDate;
  const dateNow = new Date(Date.now());
  const isDesktop = useMediaQuery("desktop");

  const isDisplayed = useMemo(() => {
    if (store?.active_subscription) return false;
    if (date > dateNow) return true;

    return false;
  }, [account, store, account?.created_at, store?.last_updated_at]);

  if (!isDisplayed || excludePaths.includes(window.location.pathname))
    return null;

  return (
    <S.BannerContainer>
      <S.BannerText>{t("banner.description")}</S.BannerText>
      <Button
        alignSelf="center"
        color="white"
        bgColor="green"
        padding="14px 32px"
        size="xl"
        onClick={() => setShow(true)}>
        {t("banner.button_text")}
      </Button>

      <CountdownTimer
        key={window.location.pathname}
        targetDate={date}
        bgColor="borderSecondary"
        numberColor="text"
        textColor="text"
        width="67px"
        height="60px"
        numberSize="23px"
        minutesKey="min"
        secondsKey="secs"
      />

      <Modal
        hide={() => setShow(false)}
        isShowing={show}
        minWidth={isDesktop ? "50%" : "80%"}>
        <Plans closeModal={() => setShow(!show)} />
      </Modal>
    </S.BannerContainer>
  );
};
